{
  "header": {
    "title": {
      "create": "Create price list",
      "edit": "Edit price list"
    },
    "description": {
      "create": "Choose how you want your pricing to work with automatic and manual pricing.",
      "update": "Choose how you want your pricing to work with automatic and manual pricing."
    }
  },
  "details": {
    "title": "Details",
    "name": {
      "label": "Name",
      "placeholder": "e.g. Wholesale pricing"
    },
    "handle": {
      "label": "Handle (or ID)",
      "placeholder": "e.g. wholesale-pricing",
      "tooltip": "Uniquely identifies this price list. Particularly useful if you're connecting to SparkLayer via a third-party integration or custom development."
    },
    "currency": {
      "label": "Currency",
      "placeholder": "Please select a currency"
    },
    "no_changing_handle_or_currency": "The price list handle and currency cannot be changed once a price list has been created."
  },
  "automatic_pricing": {
    "title": "Automatic pricing",
    "enable": {
      "label": "Enable automatic pricing",
      "description": "Create a flat discount from a price list."
    },
    "pricing_source": {
      "label": "Pricing source",
      "placeholder": "Select a price list",
      "groups": {
        "custom": "Manually created price lists",
        "platform": "Platform price lists",
        "integration": "Integration price lists"
      }
    },
    "percentage_variation": {
      "enable": "Apply a percentage variation",
      "direction": {
        "minus": "Decrease",
        "plus": "Increase"
      },
      "description": "Apply a percentage variation to all pricing in \"{name}\".",
      "tax": {
        "title": "Adjust pricing to handle tax",
        "description": "SparkLayer stores and transacts prices net of tax. Because your pricing source includes tax, enter your tax rate below. We will automatically adjust the percentage variation above to strip the tax out of the prices we store.",
        "example": "Example: With a 20% tax rate, a {currencySymbol}100 product will be displayed as {currencySymbol}83.33.",
        "adjust": "Adjust pricing"
      }
    },
    "currency_conversion": {
      "enable": {
        "label": "Currency conversion",
        "description": "Use a manual exchange rate for {currency}"
      },
      "same_currency": "Please note: the currency of this price list and the selected source price list are the same ({currency})."
    }
  },
  "manual_pricing": {
    "title": "Manual pricing",
    "description": "Set specific prices for each product by uploading a CSV file.",
    "disabled_alert": {
      "message": "Manual pricing is managed by uploading a CSV file on the price lists page.",
      "price_lists_button": "Go to price lists"
    },
    "enable": {
      "label": "Enable manual pricing",
      "description": "Set specific prices for each product by uploading a CSV file."
    },
    "quantity_pricing": "To set up quantity pricing, every row needs a quantity. Otherwise, leave the column out.",
    "display_tax_rate": "To show tax-inclusive prices, add a column named \"display_tax_rate\" with each SKU's tax percentage, for example 10 for 10% GST. The rate applies to the whole SKU, so use the same value on every row for that SKU. Any SKU without a rate is treated as 0%: it shows its net price while still being labelled tax inclusive.",
    "get_started": "To get started, you'll need to set up the following columns in your CSV file.",
    "csv_table_caption": "Example CSV file",
    "download_csv_template": "Download CSV template",
    "errors": {
      "title": "CSV errors",
      "description": "There were issues found. Please review these before continuing."
    },
    "file_upload": {
      "hint": "Upload a CSV file or drag a file here."
    }
  },
  "tax_inclusive_display": {
    "title": "Tax-inclusive display",
    "description": "Show prices on this price list inclusive of tax. This changes what buyers see, not what they are charged \u2014 prices are still stored and transacted net, and your platform still calculates the tax at checkout.",
    "toggle": {
      "label": "Show tax-inclusive prices",
      "description": "Uses the \"display_tax_rate\" column from your CSV upload. SKUs with no rate, or a rate of 0, show their net price and are still labelled as tax inclusive."
    },
    "rule_derived_warning": {
      "title": "Tax rates are inherited from the source price list",
      "message": "Any SKU priced by your pricing rule uses the tax rate from that SKU on the source list. If the source list is in a different currency, its tax rate will still be applied here, which is unlikely to be right for a different market. And if the source list is one we import from your store, rather than one you uploaded, it has no tax rates to inherit, so those prices show at 0% while still being labelled tax inclusive."
    }
  },
  "actions": {
    "create": "Create price list",
    "update": "Update price list"
  },
  "notifications": {
    "errors": {
      "select_price_list": "Please select a price list.",
      "price_list_csv": "There were issues with your price list CSV file.",
      "duplicate_slug": "A price list with this handle already exists.",
      "download": "Failed to download CSV.",
      "tax_adjust": "An error occurred when adjusting for tax. Please ensure the tax value is a valid number."
    },
    "success": {
      "create": "Price list \"{name}\" successfully created.",
      "update": "Price list \"{name}\" successfully updated."
    }
  }
}
